export enum verificationStatus {
    NotVerified = -1,
    Any = 0,
    Verified = 1,
}